module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/icons/instagram-056733ed19119d64a03e188aaa4a0ae6.svg";